import dayjs from "dayjs";
import { useEffect } from "react";

type UseDatesGuardParams = {
  departureDate: Date | null;
  returnDate: Date | null;
  setReturnDate: (date: Date | null) => void;
};

export function useDatesGuard(params: UseDatesGuardParams) {
  const { departureDate, returnDate, setReturnDate } = params;

  useEffect(() => {
    if (!returnDate || !departureDate) return;

    if (dayjs(returnDate).isBefore(departureDate, "day")) {
      setReturnDate(departureDate);
    }
  }, [departureDate, returnDate, setReturnDate]);
}
